<template>
  <v-container fluid class="landing-fluid-wrapper pa-0">
    <header class="landing-bots-header px-4">
      <v-container class="landing-bots-header-inner-wrapper">
        <div class="landing-bots-header-welcome">
          <h1>Get the most value out of BOTTER</h1>
          <p>
            Welcome back to your account dashboard. Here’s what's happening
            across your bots right now.
          </p>
          <small>My Insights</small>
          <v-layout>
            <v-flex xs4>
              <p class="bots-insight">
                <span class="value">
                  {{ bots.length }}
                </span>
                <span>Bot{{ bots.length > 1 ? "s" : "" }}</span>
              </p>
            </v-flex>
          </v-layout>
        </div>
        <div class="landing-bots-header-overlay">
          <img src="../assets/img/home-01.svg" height="600" alt="" />
        </div>
      </v-container>
    </header>

    <v-container
      v-if="common.hasPermissions('bot_end_points', ['read', 'create'])"
    >
      <v-layout>
        <v-flex md6>
          <h1 class="mt-0">My Chatbots</h1>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex md2 v-for="bot in bots" :key="bot.id">
          <div
            class="card-curvey bots-list text-xs-center pointer-cursor"
            primary-title
          >
            <bot-actions
              v-if="common.hasPermissions('bot_end_points', ['read', 'delete'])"
              :bot="bot"
              @reloadBots="getUserBots"
              @editBot="editBot"
            />
            <div class="bot-info" @click="selectBot(bot)">
              <img
                width="50"
                :src="
                  bot.image
                    ? bot.image
                    : require('../assets/img/default-bot-3.png')
                "
                alt="Avatar"
              />

              <h3 class="mb-0 mt-1">{{ bot.title }}</h3>
              <v-chip class="ma-2"> Active </v-chip>
            </div>
            <!-- <div class="bot-action" @click="selectBot(bot)">
                            Manage Bot
                        </div> -->
          </div>
        </v-flex>
        <v-flex md2>
          <div
            v-if="common.hasPermissions('bot_end_points', ['read', 'create'])"
            class="card-curvey text-xs-center pointer-cursor pa-1"
            @click="addDialog = true"
          >
            <v-btn
              large
              round
              flat
              block
              :ripple="false"
              class="primary--text btn-no-hover"
              color="white"
            >
              <v-icon>add_circle_outline</v-icon>
              Add Bot
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="addDialog" persistent width="500">
      <bot-add-dialog
        :bot="currentBot"
        @closeDialog="()=> {
          addDialog = false;
          currentBot = {};
        }"
        @reloadBots="getUserBots"
      />
    </v-dialog>
    <bot-migration
      v-if="common.hasPermissions('bot_end_points', ['read', 'create'])"
      :bot-import-dialog="importDialog"
      @closeDialog="importDialog = false"
      @reloadBots="getUserBots"
      source="home"
    />
  </v-container>
</template>

<script>
import botActions from "../components/bots/botActions";
import botAddDialog from "../components/bots/botAddDialog";
import botMigration from "../components/settings/general-setings/chnnaelConfiguration/botMigration";
import common from "../utils/common";
export default {
  name: "Bots",
  components: {
    botAddDialog,
    botActions,
    botMigration,
  },
  data() {
    return {
      common,
      bots: [],
      addDialog: false,
      importDialog: false,
      currentBot: {}
    };
  },
  async mounted() {
    await this.getUserBots();
    this.$store.dispatch("setBotId", "");
    localStorage.setItem("botId", "");
  },
  methods: {
    async getUserBots() {
      const response = await this.$http.get("/bot/my");

      this.bots = [];
      this.bots = response.data;
      await this.setAllBots(response);
      this.handleAutoSelect();
    },
    async setAllBots({ data }) {
      localStorage.setItem("allBots", JSON.stringify(data));
      await this.$store.dispatch("setAllBots", data);
    },
    async selectBot(bot, redirect = "build") {
      const botId = bot.id;
      await this.$store.dispatch("setBotId", botId);
      localStorage.setItem("botId", botId);
      await this.$store.dispatch("setBotTitle", bot.title);
      localStorage.setItem("botTitle", bot.title);

      if (redirect) {
        this.$router.push(redirect);
        window.location.reload();
      }
    },
    async handleAutoSelect() {
      if (this.bots.length) {
        const botId = this.bots[0];
        if (this.$store.state.user.roleId === 2) {
          this.selectBot(botId, "/chat-history");
        } else if (this.$store.state.user.roleId === 3) {
          this.selectBot(botId, "/insights");
        }
      }
    },
    editBot(bot) {
      this.currentBot = bot;
      this.addDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped src="../assets/sass/commponents/bots.scss"></style>
